import { IService } from './IService'
import { ServiceLocator } from './ServiceLocator'

export class BaseService implements IService {
  constructor(protected readonly serviceLocator: ServiceLocator) {}
}
